(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathVersionStorefrontDetail", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/version/storefrontConfig/learningPathVersionStorefrontDetailView.html",
            controller: ["learningPathVersionStorefrontResource", "messageService", "$translate", "$stateParams", "$localStorage", "_", LearningPathVersionStorefrontDetailCtrl],
            controllerAs: "vm"
        };
        function LearningPathVersionStorefrontDetailCtrl(learningPathVersionStorefrontResource, messageService, $translate, $stateParams, $localStorage, _) {
            var vm = this;
            vm.showErrors = false;
            vm.model = {
                number: $stateParams.number, version: $stateParams.version
            };
            vm.loading = true;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 300,
                plugins: "autoresize code wordcount",
                language: lang
            };
            learningPathVersionStorefrontResource.getDetail({ number: $stateParams.number, version: $stateParams.version }, function (result) {
                angular.extend(vm.model, result);
                vm.indexPosition = result.mediaDescriptions.indexOf(result.mediaDescriptions[0]);
                vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                vm.detail = _.find(result.mediaDescriptions, { localizationId: vm.selectedLocalizationId });
                checkDetails();
                //copyOriginalDetail();
                vm.loading = false;
            });
            vm.save = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                //angular.extend(vm.detail, $stateParams);
                vm.detail.localizationId = vm.selectedLocalizationId;
                learningPathVersionStorefrontResource.saveDetail(vm.model, function (result) {
                    angular.extend(vm.model, result);
                    vm.indexPosition = result.mediaDescriptions.indexOf(result.mediaDescriptions[0]);
                    vm.detail = _.find(result.mediaDescriptions, { localizationId: vm.selectedLocalizationId });
                    checkDetails();
                    //copyOriginalDetail();
                    vm.saving = false;
                    messageService.success("common.recordSaved");
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            //vm.upload = function (file) {
            //	vm.file = file;
            //	if (file) {
            //		file.upload = Upload.upload({
            //			url: "api/learningPathVersionStorefront/" + vm.model.number + "/" + vm.model.version + "/" + vm.selectedLocalizationId + "/upload",
            //			data: {
            //				file: file
            //			}
            //		});
            //		file.upload.then(function (response) {
            //			$timeout(function () {
            //				vm.detail.mediaUrl = response.data.details.fileUrl;
            //				vm.detail.mediaFileName = response.data.details.fileName;
            //				vm.detail.catalogMediaUrl = response.data.catalog.fileUrl;
            //				vm.detail.catalogMediaFileName = response.data.catalog.fileName;
            //				vm.detail.shoppingCartMediaUrl = response.data.shoppingCart.fileUrl;
            //				vm.detail.shoppingCartMediaFileName = response.data.shoppingCart.fileName;
            //				messageService.success("common.dropzone.uploadedFileMessage");
            //				vm.file.progress = 0;
            //			});
            //		}, function (response) {
            //			if (response.status > 0) {
            //				messageService.error(response);
            //			}
            //			vm.file.progress = 0;
            //		}, function (evt) {
            //			file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
            //		});
            //	}
            //};
            //vm.removeImage = function () {
            //	vm.detail.mediaUrl = null;
            //	vm.detail.mediaFileName = null;
            //};
            vm.changeLocalization = function (localizationId) {
                changeLanguage(localizationId);
                //if (vm.selectedLocalizationId !== localizationId) {
                //	if (!angular.equals(vm.detailOriginal, vm.detail)) {
                //		var modal = $uibModal.open({
                //			templateUrl: "unSavedDataWillBeLost.html",
                //			backdrop: false,
                //			animation: false,
                //			windowClass: "confirmation-modal",
                //			controller: ["$scope", function ($scope) {
                //				var unSavedChangesVm = this;
                //				unSavedChangesVm.dontSave = function () {
                //					changeLanguage(localizationId);
                //					$scope.$dismiss();
                //				};
                //			}],
                //			controllerAs: "unSavedChangesVm"
                //		});
                //		modal.result.then(function () {
                //			vm.save();
                //			changeLanguage(localizationId);
                //		}, function () {
                //			$("#" + vm.selectedLocalizationId).focus();
                //		});
                //	} else {
                //		changeLanguage(localizationId);
                //	}
                //}
            };
            function changeLanguage(localizationId) {
                vm.selectedLocalizationId = localizationId;
                vm.detail = _.find(vm.model.mediaDescriptions, { localizationId: localizationId });
                checkDetails();
                //copyOriginalDetail();
                vm.indexPosition = vm.model.mediaDescriptions.indexOf(vm.selectedDetailLocalization);
            }
            //function copyOriginalDetail() {
            //	vm.detailOriginal = angular.copy(vm.detail);
            //}
            function checkDetails() {
                if (!vm.detail)
                    vm.detail = {};
            }
        }
    });
}());
